/**
 * Matches key value pair of an object
 * and returns only distinct object
 */
export default function unique_objects (key, array = []) {
  const cache = {}
  return array.reduce((p, o) => {
    if (!o) return p

    if (!cache[o[key]]) {
      cache[o[key]] = true
      p.push(o)
    }
    return p
  }, [])
}
